import { render, staticRenderFns } from "./Bahan.vue?vue&type=template&id=22032a8e&"
import script from "./Bahan.vue?vue&type=script&lang=js&"
export * from "./Bahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports